import React from 'react';
import { Registry, TaxRegimeCode } from '@/graphql/__generated__/onboarding-legal';
import { TaxRegimeCodeMap } from '@/utils/maps';
import TextSection from './TextSection';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';

interface CompanyInformationProps {
	registry: Registry;
}

export const CompanyInformation: React.FC<CompanyInformationProps> = ({ registry }) => {
	const t = useTranslations('RegistryDetails');
	const taxRegimeCode =
		TaxRegimeCodeMap[registry.companyInformation?.taxRegimeCode as TaxRegimeCode] || '';

	return (
		<div className="space-y-3">
			<TextSection
				label="Names"
				value={registry.companyInformation?.legalName}
				field="LegalName"
				sectionName="CompanyInformation"
			/>
			<TextSection
				label="RFC"
				value={registry.companyInformation?.rfc}
				field="Rfc"
				sectionName="CompanyInformation"
			/>
			<TextSection
				label="TaxRegimeCode"
				value={t(toTranslationKey(taxRegimeCode))}
				field="TaxRegimeCode"
				sectionName="CompanyInformation"
			/>
			<TextSection
				label="CompanyPhoneNumber"
				value={registry.companyInformation?.companyPhoneNumber}
				field="CompanyPhoneNumber"
				sectionName="CompanyInformation"
			/>
		</div>
	);
};

export default CompanyInformation;
